// extracted by mini-css-extract-plugin
export default {"ipad_layout":"index_ipad_layout_MNRmu","layout":"index_layout_aea8M"};